import { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext(null);

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  const addToast = useCallback((message, type = 'info', duration = 3000) => {
    // Generate a cryptographically secure unique ID to avoid collisions
    const uniqueId = crypto.randomUUID();

    setToasts((prev) => [...prev, { id: uniqueId, message, type, duration }]);

    if (duration > 0) {
      setTimeout(() => {
        removeToast(uniqueId);
      }, duration);
    }
    return uniqueId;
  }, [removeToast]);

  return (
    <ToastContext.Provider value={{ addToast, removeToast, toasts }}>
      {children}
    </ToastContext.Provider>
  );
};
